import { render, staticRenderFns } from "./evaluate-existing-footbath.vue?vue&type=template&id=0413b6c5&"
import script from "./evaluate-existing-footbath.vue?vue&type=script&lang=js&"
export * from "./evaluate-existing-footbath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports